import React from 'react';

import CVRailDocument from '../rail-document.component';
import { localizedPage, useLocalizedPage } from '../i18n/localized-page';

import english from './locales/guide.en';

// The full user guide, with a contents rail that follows the reader. The page
// itself is written out once per language in locales/.

const PAGES = localizedPage(english, code => import(/* webpackChunkName: "[request]" */ `./locales/guide.${code}`));

const CaptiVisionGuide = () => {
    const [page, lang] = useLocalizedPage(PAGES);

    return (
        <CVRailDocument
            lang={lang}
            pageTitle={page?.title}
            className="cv-guide"
            contents={page?.contents}
            railLabel={page?.railLabel}
            navCurrent="User guide"
            footerCurrent="User guide"
            head={page?.head}>
            {page?.body}
        </CVRailDocument>
    )
}

export default CaptiVisionGuide;
